import React from 'react';

const TIME_RANGE_RE =
  /\s+((?:hôm nay|hôm qua|tháng này|tháng trước|năm nay|tuần này|tuần trước|ngày)\b.*)$/i;

const toSentenceCase = (value: string): string => {
  const lower = value.toLocaleLowerCase('vi');
  if (!lower) return lower;
  return lower.charAt(0).toLocaleUpperCase('vi') + lower.slice(1);
};

interface ReportTitleProps {
  text: string;
  className?: string;
}

export const ReportTitle: React.FC<ReportTitleProps> = ({
  text,
  className = 'rr-title',
}) => {
  const displayText = toSentenceCase(text);
  const match = displayText.match(TIME_RANGE_RE);

  if (match && match.index !== undefined) {
    return (
      <span className={className}>
        <span className="rr-title-name">{displayText.slice(0, match.index)}</span>
        <span className="rr-title-range">{match[0]}</span>
      </span>
    );
  }

  return <span className={className}>{displayText}</span>;
};
